import { useState } from 'react';

const speakerName = (turn) => {
  if (turn.speaker) return `${turn.speaker.firstName || ''} ${turn.speaker.lastName || ''}`.trim() || 'TBA';
  return turn.requiresDebaters ? 'Assign debaters in Assignments' : 'Speaker not assigned';
};
const sideLabel = (turn) => turn.side ? turn.side.toUpperCase() : turn.role || 'Speaker';
const sideClass = (turn) => turn.side ? `debate-side-badge-${turn.side}` : 'debate-side-badge-moderator';

export default function DebateSubAgenda({ turns, index, onSelect, disabled = false, expanded: controlledExpanded, onToggle }) {
  const [localExpanded, setLocalExpanded] = useState(false);
  const expanded = controlledExpanded ?? localExpanded;
  const setExpanded = onToggle ? () => onToggle() : setLocalExpanded;
  if (!turns?.length) return null;
  const current = turns[index];
  const row = (turn, turnIndex) => <>
    <span className="debate-sub-agenda-number">{turnIndex + 1}.</span>
    <span className="debate-sub-agenda-title">{turn.title}</span>
    <span className={`debate-side-badge ${sideClass(turn)}`}>{sideLabel(turn)}</span>
    <span className="debate-sub-agenda-speaker">{speakerName(turn)}</span>
  </>;

  return <section className="debate-assignments debate-sub-agenda p-3 mb-3" aria-label="Debate sub-agenda">
    <div className="debate-assignments-heading">
      <button type="button" className="debate-assignments-kicker debate-assignments-toggle"
        aria-expanded={expanded} onClick={() => setExpanded(value => !value)}>
        <span aria-hidden="true">{expanded ? '▾' : '▸'}</span> Sub-agenda
      </button>
      <small className="debate-assignments-kicker">{turns.length} turns</small>
    </div>
    {!expanded
      ? current && <div className="debate-sub-agenda-row is-current" aria-label="Current turn">{row(current, index)}</div>
      : <ol className="debate-sub-agenda-list">
        {turns.map((turn, turnIndex) => {
          const className = `debate-sub-agenda-row${turnIndex === index ? ' is-current' : ''}${turnIndex < index ? ' is-done' : ''}`;
          const current = turnIndex === index ? 'step' : undefined;
          return <li key={turn.id}>
            {onSelect
              ? <button type="button" className={className} aria-current={current}
                disabled={disabled} onClick={() => onSelect(turnIndex)}>
                {row(turn, turnIndex)}
              </button>
              : <div className={className} aria-current={current}>{row(turn, turnIndex)}</div>}
          </li>;
        })}
      </ol>}
  </section>;
}
